/**
 * Labstep
 *
 * @module components/App/Routes/Redirection
 * @desc Redirects to the correct route based on the current route
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { Redirect } from 'react-router-dom';
import type { AppRoutesRedirectionProps } from './types';

export const redirectRoutes = {
  [navigation.get('overview')]: 'group_show',
  [navigation.get('tag_index')]: 'group_settings_experiment_tags',
  [navigation.get('protocol_collection_index')]:
    'group_protocol_collections',
  [navigation.get('experiment_workflow_index')]:
    'group_experiment_workflows',
  [navigation.get('entity_view_index')]: 'group_entity_views',
  [navigation.get('experiment_workflow_template_index')]:
    'group_settings_experiment_workflow_templates',
  [navigation.get('order_request_index')]: 'group_order_requests',
  [navigation.get('purchase_order_index')]: 'group_purchase_orders',
  [navigation.get('resource_template_index')]:
    'group_settings_inventory_categories',
  [navigation.get('device_template_index')]:
    'group_settings_device_categories',
  [navigation.get('resource_index')]: 'group_resources',
  [navigation.get('resource_item_index')]: 'group_resource_items',
  [navigation.get('device_index')]: 'group_devices',
  [navigation.get('file_index')]: 'group_files',
  [navigation.get('resource_location_index')]:
    'group_settings_inventory_locations',
  [navigation.get('settings')]: 'group_settings',
  [navigation.get('settings_notifications')]:
    'group_settings_notifications',
  [navigation.get('settings_order_info')]:
    'group_settings_purchase_order_template',
  [navigation.get('user_index')]: 'group_users',
} as const;

export const AppRoutesRedirection: React.FC<
  AppRoutesRedirectionProps
> = ({ location, activeGroup }) => {
  const { pathname, search } = location;

  let to = navigation.get('login');
  if (activeGroup && activeGroup.id) {
    to = `${navigation.get(redirectRoutes[pathname], {
      id: activeGroup.id,
    })}${search}`;
  }

  return <Redirect to={to} />;
};

export default withActiveGroup(AppRoutesRedirection);
